import { createMuiTheme } from '@material-ui/core'

const theme = createMuiTheme({
  typography: {
    body1: {
      fontFamily: 'Nunito',
      color:'#4F5052',
      fontWeight:600,
      textTransform:'none'
    }
  }
});

export default theme;
